import React, { useState } from "react";
import { TableCell, TableRow } from "@mui/material";
import lodash from "lodash";

import BoxGrid from "../boxGrid/boxGrid";
import KogCheckbox from "../checkbox/kogCheckbox";
import { firstLetterToUpperCase } from "@/main/services/utilsString";

interface IOptionElement {
	content: string | React.ReactNode;
	width?: string | number;
}

export type IOptionGridCheckbox = {
	id: string;
	elements: IOptionElement[];
};

interface IKOGBoxGridCheckboxProps {
	rowHeaders: string[] | React.ReactNode[];
	marginCustom?: string;
	options: IOptionGridCheckbox[];
	optionsSelected: string[];
	setOptionsSelected: (data: string[]) => void;
	onChangeCustom?: (data: string[]) => void;
	onClickCustom?: (option: IOptionGridCheckbox, event: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => void;
}

function KOGBoxGridCheckbox({
	options,
	rowHeaders,
	optionsSelected,
	marginCustom,
	setOptionsSelected,
	onChangeCustom = () => {},
	onClickCustom = () => {},
}: IKOGBoxGridCheckboxProps) {
	const [allSelected, setAllSelected] = useState(optionsSelected.length === options.length);

	function handleToggleCheckbox(guid: string) {
		const cloneOptionsSelected = lodash.cloneDeep(optionsSelected);
		const index = cloneOptionsSelected.indexOf(guid);

		if (index > -1) {
			cloneOptionsSelected.splice(index, 1);
		} else {
			cloneOptionsSelected.push(guid);
		}

		const allSelecteds = cloneOptionsSelected.length === options.length;

		setAllSelected(allSelecteds);
		setOptionsSelected(cloneOptionsSelected);
		onChangeCustom(cloneOptionsSelected);
	}
	function handleToggleSelectAll() {
		if (allSelected) {
			setOptionsSelected([]);
			onChangeCustom([]);
			setAllSelected(false);
			return;
		}
		const allGuids = options.map((option) => option.id);
		setOptionsSelected(allGuids);
		onChangeCustom(allGuids);
		setAllSelected(true);
	}

	return (
		<BoxGrid
			typeGrid="default"
			sizeCell="small"
			marginCustom={marginCustom}
			rowHeaders={[
				<KogCheckbox
					key="checkbox"
					checked={allSelected}
					value={allSelected}
					onChange={handleToggleSelectAll}
					id="id-boxGrid-checkbox-selectAll"
				/>,
				...rowHeaders,
			]}
		>
			{options.map((option) => (
				<TableRow key={option.id} onClick={(e) => onClickCustom(option, e)}>
					<TableCell width="40px">
						<KogCheckbox
							className="ignore-click"
							id={`id-boxGrid-checkbox-${option.id}`}
							onChange={() => handleToggleCheckbox(option.id)}
							checked={optionsSelected.includes(option.id)}
							value={optionsSelected.includes(option.id)}
						/>
					</TableCell>
					{option.elements.map((item, index) => (
						<TableCell key={`${option.id}-${index}`} width={item.width} id={`id-grid-${option.id}`}>
							{typeof item.content === "string" ? firstLetterToUpperCase(item.content) : item.content}
						</TableCell>
					))}
				</TableRow>
			))}
		</BoxGrid>
	);
}

export default KOGBoxGridCheckbox;
